import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة ارتفاع شبه المنحرف";
const DESCRIPTION =
  "تعتبر حاسبة ارتفاع شبه المنحرف أداة مفيدة لحساب الارتفاع بناءً على مساحة شبه المنحرف وطولي قاعدتيه. توفر هذه الحاسبة طريقة سريعة ودقيقة لإيجاد الارتفاع المطلوب في أي مسألة هندسية تتعلق بشبه المنحرف.";
const KEYWORDS = "ارتفاع, شبه المنحرف, حاسبة, هندسة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/trapezoid-height-calculator/";
const TrapezoidHeightCalculator = () => {
  const [area, setArea] = useState("");
  const [base1, setBase1] = useState("");
  const [base2, setBase2] = useState("");
  const [height, setHeight] = useState("");
  const [error, setError] = useState("");
  const calculateHeight = (area, base1, base2) => {
    return (2 * area) / (parseFloat(base1) + parseFloat(base2));
  };
  const handleCalculate = () => {
    try {
      const areaValue = parseFloat(area);
      const base1Value = parseFloat(base1);
      const base2Value = parseFloat(base2);
      if (area && base1 && base2) {
        const calculatedHeight = calculateHeight(
          areaValue,
          base1Value,
          base2Value
        );
        setHeight(calculatedHeight.toFixed(2));
        setError("");
      } else {
        throw new Error("يرجى إدخال جميع القيم لحساب الارتفاع.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة ارتفاع شبه المنحرف</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تعتبر حاسبة ارتفاع شبه المنحرف أداة متقدمة وسهلة الاستخدام
                  تساعدك في حساب الارتفاع بدقة استنادًا إلى مساحة شبه المنحرف
                  وطولي قاعدتيه. تُستخدم هذه الحاسبة بشكل رئيسي في مسائل الهندسة
                  وحسابات التصميم، حيث توفر لك نتائج سريعة وموثوقة لتحديد
                  الارتفاع الضروري لشبه المنحرف. سواء كنت تعمل على مشاريع
                  هندسية، أو تحتاج لحسابات دقيقة في مجال البناء أو التصميم، فإن
                  هذه الأداة توفر لك طريقة فعالة للتعامل مع المسائل المعقدة
                  المتعلقة بشبه المنحرف.
                  </p>
                  <ul>
                    <li>
                      <strong>مثال عملي:</strong> إذا كانت مساحة شبه المنحرف 100
                      متر مربع وطول القاعدة الكبرى 12 مترًا وطول القاعدة الصغرى
                      8 أمتار، يمكنك إدخال هذه القيم في الحاسبة للحصول على
                      الارتفاع بدقة.
                    </li>
                    <li>
                      <strong>فوائد:</strong> تساعدك هذه الحاسبة في تجنب الأخطاء
                      اليدوية وتوفير الوقت في الحسابات الدقيقة، مما يجعلها أداة
                      أساسية للمهندسين والمعماريين.
                    </li>
                  </ul>
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة ارتفاع شبه المنحرف</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          مساحة شبه المنحرف
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل المساحة"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">متر²</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          طول القاعدة الأولى
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل طول القاعدة الأولى"
                        value={base1}
                        onChange={(e) => setBase1(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">متر</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          طول القاعدة الثانية
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل طول القاعدة الثانية"
                        value={base2}
                        onChange={(e) => setBase2(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2">متر</span>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { height && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتائج:</p>
                        <p>ارتفاع شبه المنحرف (متر): {height}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو شبه المنحرف؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                شبه المنحرف هو شكل رباعي الأضلاع يتكون من ضلعين متوازيين يسمى كل
                منهما قاعدة، وضلعين آخرين غير متوازيين. يعتبر شبه المنحرف من
                الأشكال الهندسية التي يمكن حساب مساحتها باستخدام طولي القاعدتين
                والارتفاع.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف يتم حساب ارتفاع شبه المنحرف؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                يتم حساب ارتفاع شبه المنحرف باستخدام العلاقة بين مساحته وطولي
                القاعدتين. المعادلة المستخدمة هي: الارتفاع = (2 × المساحة) ÷
                (القاعدة الأولى + القاعدة الثانية). هذه المعادلة تعتمد على حقيقة
                أن مساحة شبه المنحرف تساوي نصف مجموع طولي القاعدتين مضروبًا في
                الارتفاع.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                أمثلة على استخدامات شبه المنحرف
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                يُستخدم شبه المنحرف في العديد من التطبيقات الهندسية والمعمارية.
                على سبيل المثال، يمكن استخدامه في تصميم الأسقف المائلة، الجسور،
                وبعض أنواع الآلات. فهم كيفية حساب مساحته وارتفاعه ضروري في مثل
                هذه التطبيقات لضمان دقة التصميم والاستقرار الهيكلي.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TrapezoidHeightCalculator;
